(function () {
	const win = window;
	if (win.__arModalProjetoInitialized) return;
	win.__arModalProjetoInitialized = true;

	const modal = document.getElementById("ar-modal-projeto");
	const backBtn = document.getElementById("ar-mp-back-btn");
	const closeBtn = document.getElementById("ar-mp-close-btn");
	if (!modal || !backBtn || !closeBtn) return;

	const confirmOverlay = document.getElementById("ar-mp-confirm-exit");
	const confirmTitle = document.getElementById("ar-mp-confirm-title");
	const confirmMessage = document.getElementById("ar-mp-confirm-message");
	const confirmStayBtn = document.getElementById("ar-mp-confirm-stay-btn");
	const confirmSkipBtn = document.getElementById("ar-mp-confirm-skip-btn");
	const confirmLeaveBtn = document.getElementById("ar-mp-confirm-leave-btn");
	const successCloseBtn = document.getElementById("ar-mp-success-close-btn");
	const container = modal.querySelector(".modal-container");
	const content = modal.querySelector(".modal-content");

	const DEBUG = /[?&]quiz_debug=1\b/.test(window.location.search);
	const LOG_PREFIX = "[ar-modal-projeto]";

	const PORTAL_ID = "39596724";
	const FORM_ID = "517d4924-e0e7-47ce-bf38-c9277580593a";
	const SUBMIT_URL = "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + FORM_ID;

	const FILE_FORM_ID = "da601bc1-c90a-4cd7-bb5c-f79a1eb94c76";
	const FILE_FIELD = "arquivos_cozinha";
	const FILE_UPLOAD_URL = "https://forms.hubspot.com/uploads/form/v2/" + PORTAL_ID + "/" + FILE_FORM_ID;
	const UPLOAD_IFRAME_NAME = "ar-mp-file-upload-frame";
	const MAX_FILE_MB = 100;
	const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;

	// Página de agradecimento após concluir o formulário (fixa, não depende do parâmetro da seção)
	const SUCCESS_URL = "https://madesa.ar/pages/diseno-de-cocina-gracias";
	const THANKYOU_URL = modal.dataset.thankyouUrl || SUCCESS_URL;
	const SUCCESS_UPLOAD_MAX_WAIT_MS = 20000;
	const REDIRECT_ON_EXIT = modal.dataset.redirectOnExit !== "false";
	const REDIRECT_ON_CLOSE_MIN_STEP = 2;
	const SUCCESS_REDIRECT_DELAY_MS = 1500;
	const FILE_UPLOAD_WAIT_MS = 12000;
	const IP_LOOKUP_TIMEOUT_MS = 1500;

	const STORAGE_KEY = "modal-projeto-ar-progress";
	const GCLID_KEY = "__gclid_ar";
	const PROGRESS_TTL_MS = 7 * 24 * 60 * 60 * 1000;
	const MONTHS_AHEAD = 12;

	const EARLY_LEAD_CAPTURE = true;
	const SEND_COMPLETED_EXIT_STEP = true;

	const PHONE_DDI = "54";
	const PHONE_MOBILE_9 = "9";

	const FIELD_MAP = {
		nome: "firstname",
		email: "email",
		telefone: "phone",
		formato: "selecciona_el_formato_de_tu_nueva_cocina",
		medidas: "cual_es_la_medida_de_tu_formato",
		linha: "ar_cual_de_nuestras_lineas_le_gusto_mas",
		color: "que_color_prefiere_usted_",
		espacio: "el_espacio_ya_esta_listo_para_recibir_los_muebles_ar",
		dataCompra: "cuando_quieres_realizar_la_compra_de_tu_cocina_",
		presupuesto: "ar_cual_es_tu_presupuesto_para_una_cocina_nueva",
		gclid: "",
		sku: "",
	};

	const VALUE_MAP = {
		formato: {
			"lineal": "Cocina Lineal",
			"esquinera": "Cocina Esquinera",
			"paralela": "Cocina Paralela",
			"en-u": "Cocina en U",
			"otro": "",
		},
		linha: {
			"lux": "Lux $$$$$",
			"vik": "Vik $$$$",
			"agata": "Agata $$$",
			"glamy": "Glamy $$$",
			"stella": "Stella $$$",
			"acordes": "Acordes $$$",
			"nice": "Nice $$",
			"reims": "Reims $",
		},
		color: {
			"gris": "Gris",
			"negro": "Negro",
			"blanco": "Blanco",
			"crema": "Crema",
			"marron": "Marrón",
			"verde": "Verde",
			"azul": "Azul",
		},
		espacio: {
			"si": "Sí",
			"no-en-obra": "No. Todavía está en obra/planificación",
			"no-con-fecha": "No. Pero ya tengo una idea de cuándo va a estar listo",
		},
		presupuesto: {
			"menos-1m": "Menos de $1.000.000",
			"1m-2m": "$1.000.000 a $2.000.000",
			"2m-3.5m": "$2.000.000 a $3.500.000",
			"mas-3.5m": "Mais de $3.500.000",
		},
	};

	const HIDDEN_FIELDS = [
		{ name: "nacionalidade", value: "Argentina" },
		{ name: "fuente_de_registro__mexico_", value: "Quiz Proyectos" },
		{ name: "madesa_email_consent", value: "true" },
	];

	const ORIGIN_NORMAL = [
		{ name: "origem_de_cadastro_staging", value: "LP Cozinhas (Quiz)" },
		{ name: "origem_de_cadastro__crm__staging", value: "LP (Quiz)" },
	];
	const ORIGIN_DESISTENTE = "LP (Quiz) Desistentes";
	const NEVER_SEND_DIRECTLY = ["origem_de_cadastro", "origem_de_cadastro__crm_"];

	const EXIT_FIELD = "etapa_de_desistencia";
	const EXIT_STEP_COMPLETED = "Concluído";
	const EXIT_STEP = {
		2: "formato",
		3: "medidas",
		4: "linea",
		5: "color",
		6: "espacio-listo",
		7: "fecha-compra",
		8: "presupuesto",
	};

	const LEGAL_CONSENT = {
		consent: {
			consentToProcess: true,
			text: "Para brindarte el servicio, necesitamos tu autorización para almacenar y procesar tus datos personales.",
			communications: [
				{ value: true, subscriptionTypeId: 2924505825, text: "Acepto recibir comunicaciones de Madesa." },
			],
		},
	};

	const STEP_ADVANCE_EVENTS = {
		1: "contato_proyecto_ar",
		2: "formato_cocina_modal",
		3: "medidas_modal",
		4: "linea_cocina_modal",
		5: "color_cocina_modal",
		6: "espacio_listo_modal",
		7: "periodo_modal",
	};

	const WALLS_BY_FORMAT = { "lineal": 1, "esquinera": 2, "paralela": 2, "en-u": 3, "otro": 3 };
	const SINGLE_CHOICE_STEPS = [2, 4, 6, 8];
	const REQUIRED_STEPS = [1, 2, 5, 6, 7, 8];
	const WIDE_STEPS = [4, 8];

	let i18n = {};
	try {
		const i18nEl = document.getElementById("ar-modal-projeto-i18n");
		if (i18nEl) i18n = JSON.parse(i18nEl.textContent.trim());
	} catch (e) {
		console.error(LOG_PREFIX, "i18n inválido", e);
	}

	const totalSteps = Number(i18n.totalSteps) > 0 ? Number(i18n.totalSteps) : 8;
	const formData = {};
	let currentStep = 0;
	let uploadedFiles = [];
	let openerProductId = "";
	let leadCaptured = false;
	let isSubmitting = false;
	let redirecting = false;
	let redirectTimer = null;
	let pendingSuccessUploads = null;

	function log() {
		if (DEBUG) console.log.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments)));
	}

	function tpl(str, vars) {
		return String(str || "").replace(/__([A-Z]+)__/g, (m, key) => (key in vars ? String(vars[key]) : m));
	}

	const $ = (selector) => modal.querySelector(selector);
	const $$ = (selector) => modal.querySelectorAll(selector);
	const stepEl = (step) => $('.form-step[data-step="' + step + '"]');

	const store = {
		get(key) {
			try { return window.localStorage.getItem(key); } catch (e) {}
			try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
		},
		set(key, value) {
			try { window.localStorage.setItem(key, value); return; } catch (e) {}
			try { window.sessionStorage.setItem(key, value); } catch (e) {}
		},
		remove(key) {
			try { window.localStorage.removeItem(key); } catch (e) {}
			try { window.sessionStorage.removeItem(key); } catch (e) {}
		},
	};

	win.__gclidAr = "";
	try {
		const gclid = new URLSearchParams(window.location.search).get("gclid");
		if (gclid) window.sessionStorage.setItem(GCLID_KEY, gclid);
		win.__gclidAr = gclid || window.sessionStorage.getItem(GCLID_KEY) || "";
	} catch (e) {}

	function getHutk() {
		const m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
		return m ? m[2] : "";
	}

	function track(eventName) {
		try {
			if (typeof win.trackEvent === "function") win.trackEvent(eventName, {});
		} catch (e) {}

		if (eventName === "contato_proyecto_ar") {
			win.dataLayer = win.dataLayer || [];
			win.dataLayer.push({
				event: "lead_proyecto_ar",
				email: String(formData.email || "").trim().toLowerCase(),
				phone_number: String(formData.telefone || "").trim(),
				first_name: String(formData.nome || "").trim(),
				gclid: win.__gclidAr || "",
			});
		}
	}

	function saveProgress() {
		store.set(STORAGE_KEY, JSON.stringify({
			step: currentStep,
			formData: formData,
			productId: openerProductId,
			leadCaptured: leadCaptured,
			timestamp: Date.now(),
		}));
	}

	function loadProgress() {
		try {
			const progress = JSON.parse(store.get(STORAGE_KEY) || "null");
			if (!progress) return null;
			if (Date.now() - progress.timestamp > PROGRESS_TTL_MS) {
				store.remove(STORAGE_KEY);
				return null;
			}
			return progress;
		} catch (e) {
			store.remove(STORAGE_KEY);
			return null;
		}
	}

	function clearProgress() {
		store.remove(STORAGE_KEY);
	}

	function goToThankYou(delayMs, force) {
		if (redirecting && !force) return;
		if (redirectTimer) window.clearTimeout(redirectTimer);
		redirecting = true;
		redirectTimer = window.setTimeout(() => {
			window.location.href = THANKYOU_URL;
		}, delayMs || 0);
	}

	function lockScroll(locked) {
		document.documentElement.classList.toggle("ar-mp-scroll-lock", locked);
		document.body.classList.toggle("project-start-modal-open", locked);
	}

	function showConfirmExit() {
		const data = i18n.exitConfirm && i18n.exitConfirm[String(currentStep)];
		if (!confirmOverlay || !data) return false;

		confirmTitle.textContent = data.title || "";
		confirmMessage.textContent = data.message || "";
		confirmStayBtn.textContent = data.stay || "";
		confirmSkipBtn.textContent = data.skip || "";
		confirmSkipBtn.hidden = currentStep >= totalSteps;
		confirmLeaveBtn.textContent = data.leave || "";

		confirmOverlay.classList.remove("hidden");
		confirmStayBtn.focus();
		return true;
	}

	function hideConfirmExit() {
		if (confirmOverlay) confirmOverlay.classList.add("hidden");
	}

	function isConfirmOpen() {
		return !!confirmOverlay && !confirmOverlay.classList.contains("hidden");
	}

	function normalizePhone(value) {
		let d = String(value || "").replace(/\D/g, "");
		if (d.length > 10 && d.indexOf("54") === 0) {
			d = d.slice(2);
			if (d.length > 10 && d.indexOf("9") === 0) d = d.slice(1);
		}
		if (d.length > 10 && d.indexOf("0") === 0) d = d.slice(1);
		return d.slice(0, 10);
	}

	function formatPhoneTyping(value) {
		const raw = String(value || "");
		const digits = raw.replace(/\D/g, "");
		if (/^\s*\+/.test(raw) || /^(0|54)/.test(digits)) return raw.replace(/[^\d+\s()-]/g, "").slice(0, 22);
		return formatPhone(digits);
	}

	function formatPhone(value) {
		const d = normalizePhone(value);
		if (d.length <= 4) return d;
		if (d.length <= 8) return d.slice(0, 2) + " " + d.slice(2);
		return d.slice(0, 2) + " " + d.slice(2, 6) + " " + d.slice(6);
	}

	function isValidPhone(value) {
		return normalizePhone(value).length === 10;
	}

	function isValidEmail(value) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
	}

	function setFieldError(field, hasError) {
		if (!field) return;
		field.classList.toggle("is-invalid", hasError);
		field.setAttribute("aria-invalid", hasError ? "true" : "false");
	}

	function setGroupError(step, hasError) {
		const el = stepEl(step);
		if (el) el.classList.toggle("has-error", hasError);
	}

	function getActiveValue(step) {
		const btn = stepEl(step) && stepEl(step).querySelector(".option-btn.active");
		return btn ? btn.getAttribute("data-value") : "";
	}

	function getActiveColors() {
		return Array.prototype.map.call($$(".step5-color-btn.active"), (b) => b.getAttribute("data-value") || "");
	}

	function buildMonthOptions() {
		const select = $('select[name="data-compra"]');
		if (!select) return;
		const months = Array.isArray(i18n.months) && i18n.months.length === 12 ? i18n.months : null;
		const now = new Date();
		const frag = document.createDocumentFragment();

		for (let i = 0; i <= MONTHS_AHEAD; i += 1) {
			const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
			const value = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
			const option = document.createElement("option");
			option.value = value;
			option.textContent = (months ? months[d.getMonth()] : value) + " " + d.getFullYear();
			frag.appendChild(option);
		}
		select.appendChild(frag);
	}

	function isStepReady(step) {
		if (step === 1) {
			return !!(
				String(formData.nome || "").trim() &&
				isValidEmail(formData.email) &&
				isValidPhone(formData.telefone)
			);
		}
		if (step === 5) return getActiveColors().length > 0;
		if (step === 7) return !!formData.data_compra;
		if (SINGLE_CHOICE_STEPS.indexOf(step) !== -1) return !!getActiveValue(step);
		return true;
	}

	function syncNextBtnState(step) {
		if (REQUIRED_STEPS.indexOf(step) === -1) return;
		const el = stepEl(step);
		const btn = el && el.querySelector("[data-next-step]:not(.step3-skip-btn):not(.step4-skip-btn), [data-submit]");
		if (btn) btn.classList.toggle("btn--pending", !isStepReady(step));
	}

	function syncOptionalStepButtons() {
		// Passo 3: "Siguiente" sempre visível; ativo só com "Enviaré mis medidas después" marcado
		// ou com todas as paredes do formato preenchidas. "Saltar esta pregunta" não é exibido.
		const wallInputs = Array.prototype.slice.call($$('[data-step3-inputs] [name^="parede"]'));
		const hasAllMeasures = wallInputs.length > 0 && wallInputs.every((input) => input.value.replace(/\D/g, "") !== "");
		const canAdvanceStep3 = hasAllMeasures || formData.medidas_depois === "1";
		const step3AdvanceBtn = $(".step3-advance-btn");
		const step3SkipBtn = $(".step3-skip-btn");
		if (step3AdvanceBtn) {
			step3AdvanceBtn.hidden = false;
			step3AdvanceBtn.disabled = !canAdvanceStep3;
			step3AdvanceBtn.setAttribute("aria-disabled", canAdvanceStep3 ? "false" : "true");
		}
		if (step3SkipBtn) step3SkipBtn.hidden = true;

		const hasLine = !!getActiveValue(4);
		const pairs = [
			[".step4-next-btn", ".step4-skip-btn", hasLine],
		];
		pairs.forEach(([advance, skip, ready]) => {
			const advanceBtn = $(advance);
			const skipBtn = $(skip);
			if (advanceBtn) advanceBtn.hidden = !ready;
			if (skipBtn) skipBtn.hidden = ready;
		});
	}

	function renderStep3() {
		const inputsWrap = $("[data-step3-inputs]");
		const preview = $(".step3-measure-preview");
		const label = $("[data-step3-measure-label]");
		if (!inputsWrap) return;

		const format = String(formData.formato || "");
		const walls = WALLS_BY_FORMAT[format] || 0;
		const suffix = typeof i18n.unitCmSuffix === "string" ? i18n.unitCmSuffix : " cm";

		if (preview) preview.hidden = walls === 0;
		if (label) label.textContent = (i18n.measureLabel && i18n.measureLabel[format]) || "";
		$$("[data-step3-figure]").forEach((fig) => {
			fig.hidden = fig.getAttribute("data-step3-figure") !== format;
		});

		for (let i = walls + 1; i <= 3; i += 1) delete formData["parede" + i];

		inputsWrap.innerHTML = "";
		for (let i = 1; i <= walls; i += 1) {
			const name = "parede" + i;
			const digits = String(formData[name] || "").replace(/\D/g, "");

			const group = document.createElement("div");
			group.className = "form-group step3-form-group";

			const fieldLabel = document.createElement("label");
			fieldLabel.htmlFor = "ar-mp-" + name;
			fieldLabel.textContent = tpl(i18n.step3WallLabelTpl || "Pared __N__", { N: i });
			const requiredMark = document.createElement("span");
			requiredMark.className = "step3-required-mark";
			requiredMark.setAttribute("aria-hidden", "true");
			requiredMark.textContent = " *";
			fieldLabel.appendChild(requiredMark);

			const input = document.createElement("input");
			input.type = "text";
			input.id = "ar-mp-" + name;
			input.name = name;
			input.inputMode = "numeric";
			input.autocomplete = "off";
			input.placeholder = i18n.step3PlaceholderCm || "__ cm";
			input.value = digits ? digits + suffix : "";
			input.required = true;

			group.appendChild(fieldLabel);
			group.appendChild(input);
			inputsWrap.appendChild(group);
		}

		syncStep3LaterOption();
		syncOptionalStepButtons();
	}

	// "Enviaré mis medidas después": aplica o estado da opção nos campos de medida
	function syncStep3LaterOption() {
		const laterCheckbox = $('input[name="step3_medidas_depois"]');
		if (!laterCheckbox) return;
		const isLater = formData.medidas_depois === "1";
		laterCheckbox.checked = isLater;
		$$("[data-step3-inputs] input").forEach((input) => {
			input.disabled = isLater;
			if (isLater) {
				input.value = "";
				setFieldError(input, false);
				delete formData[input.name];
			}
		});
		const measureRow = $(".step3-measure-row");
		if (measureRow) measureRow.classList.toggle("is-disabled", isLater);
	}

	function renderStep5() {
		const line = String(formData.line || "");
		$$(".step5-color-btn").forEach((btn) => {
			const lines = (btn.getAttribute("data-lines") || "").split(",");
			btn.hidden = !!line && lines.indexOf(line) === -1;
			if (btn.hidden) btn.classList.remove("active");
		});
		formData.color = getActiveColors().join(",");
	}

	function formatFileSize(bytes) {
		if (bytes < 1024) return bytes + " B";
		if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB";
		return (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + " MB";
	}

	function validateFiles(files) {
		let total = 0;
		for (const file of files) {
			const isImage = file.type.indexOf("image/") === 0;
			const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
			if (!isImage && !isPdf) return i18n.fileTypeError || "";
			if (file.size > MAX_FILE_BYTES) return tpl(i18n.fileSizeErrorTpl, { NAME: file.name, MB: MAX_FILE_MB });
			total += file.size;
		}
		if (total > MAX_FILE_BYTES) {
			return tpl(i18n.fileTotalErrorTpl, { TOTAL: Math.ceil(total / (1024 * 1024)), MB: MAX_FILE_MB });
		}
		return "";
	}

	function syncUploadInput() {
		const input = $('input[name="step3_space_file"]');
		if (!input) return;
		try {
			const dt = new DataTransfer();
			uploadedFiles.forEach((f) => dt.items.add(f));
			input.files = dt.files;
		} catch (e) {
			input.value = "";
		}
	}

	function renderUploads(errorMessage) {
		const status = $("[data-upload-filename]");
		const list = $("[data-upload-list]");
		const count = uploadedFiles.length;

		formData.space_file = uploadedFiles.map((f) => f.name).join(", ");

		if (status) {
			status.classList.toggle("is-error", !!errorMessage);
			status.textContent = errorMessage
				|| (count === 1 ? i18n.uploadOne || "" : count > 1 ? tpl(i18n.uploadManyTpl, { COUNT: count }) : "");
		}
		if (!list) return;

		list.innerHTML = "";
		list.hidden = !count;
		uploadedFiles.forEach((file, index) => {
			const item = document.createElement("li");
			item.className = "step3-upload-item";

			const name = document.createElement("span");
			name.className = "step3-upload-item__name";
			name.textContent = file.name;
			name.title = file.name;

			const size = document.createElement("span");
			size.className = "step3-upload-item__size";
			size.textContent = formatFileSize(file.size);

			const remove = document.createElement("button");
			remove.type = "button";
			remove.className = "step3-upload-item__remove";
			remove.setAttribute("data-upload-remove", String(index));
			remove.setAttribute("aria-label", "Quitar " + file.name);
			remove.textContent = "×";

			item.appendChild(name);
			item.appendChild(size);
			item.appendChild(remove);
			list.appendChild(item);
		});
	}

	function addFiles(fileList) {
		const keyOf = (f) => f.name + "|" + f.size + "|" + f.lastModified;
		const known = uploadedFiles.map(keyOf);
		const candidates = uploadedFiles.concat(
			Array.prototype.filter.call(fileList || [], (f) => known.indexOf(keyOf(f)) === -1)
		);
		const error = validateFiles(candidates);
		if (!error) uploadedFiles = candidates;
		syncUploadInput();
		renderUploads(error);
	}

	function removeFile(index) {
		if (index < 0 || index >= uploadedFiles.length) return;
		uploadedFiles.splice(index, 1);
		syncUploadInput();
		renderUploads("");
	}

	function mapVal(map, slug) {
		if (!slug) return "";
		return Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : slug;
	}

	function buildFields(extra) {
		const fields = new Map();
		const push = (name, value) => {
			if (name && value !== "" && value != null) fields.set(name, String(value));
		};

		push(FIELD_MAP.nome, String(formData.nome || "").trim());
		push(FIELD_MAP.email, String(formData.email || "").trim());

		const phone = normalizePhone(formData.telefone);
		if (phone.length === 10) push(FIELD_MAP.telefone, PHONE_DDI + PHONE_MOBILE_9 + phone);

		push(FIELD_MAP.formato, mapVal(VALUE_MAP.formato, formData.formato));

		const walls = [];
		for (let i = 1; i <= 3; i += 1) {
			const digits = String(formData["parede" + i] || "").replace(/\D/g, "");
			if (digits) walls.push("Pared " + i + ": " + digits + "cm");
		}
		if (!walls.length && formData.medidas_depois === "1") {
			walls.push("Enviará las medidas después, con su especialista");
		}
		push(FIELD_MAP.medidas, walls.join(", "));

		push(FIELD_MAP.linha, mapVal(VALUE_MAP.linha, formData.line));

		push(FIELD_MAP.color, String(formData.color || "")
			.split(",")
			.filter(Boolean)
			.map((c) => mapVal(VALUE_MAP.color, c))
			.join(";"));

		push(FIELD_MAP.espacio, mapVal(VALUE_MAP.espacio, formData.espacioListo));

		const month = /^(\d{4})-(\d{2})$/.exec(String(formData.data_compra || ""));
		if (month) push(FIELD_MAP.dataCompra, Date.UTC(+month[1], +month[2] - 1, 1));

		push(FIELD_MAP.presupuesto, mapVal(VALUE_MAP.presupuesto, formData.presupuesto));
		push(FIELD_MAP.gclid, win.__gclidAr);
		push(FIELD_MAP.sku, openerProductId);

		HIDDEN_FIELDS.forEach((f) => push(f.name, f.value));
		(extra || []).forEach((f) => push(f.name, f.value));
		NEVER_SEND_DIRECTLY.forEach((name) => fields.delete(name));

		return Array.from(fields, ([name, value]) => ({ name, value }));
	}

	function postToHubspot(fields, ipAddress, keepalive) {
		const context = { pageUri: window.location.href, pageName: document.title };
		const hutk = getHutk();
		if (hutk) context.hutk = hutk;
		if (ipAddress) context.ipAddress = ipAddress;

		log("POST", fields);

		return fetch(SUBMIT_URL, {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({ fields: fields, context: context, legalConsentOptions: LEGAL_CONSENT }),
			keepalive: !!keepalive,
		}).then((res) =>
			res.json().catch(() => ({})).then((data) => {
				if (!res.ok) {
					console.error(LOG_PREFIX, "HubSpot", res.status, data);
					throw new Error((data && data.message) || "HTTP " + res.status);
				}
				return data;
			})
		);
	}

	function getIpAddress() {
		const timeout = new Promise((resolve) => window.setTimeout(() => resolve(""), IP_LOOKUP_TIMEOUT_MS));
		const lookup = fetch("https://api.ipify.org?format=json")
			.then((r) => r.json())
			.then((d) => d.ip || "")
			.catch(() => "");
		return Promise.race([lookup, timeout]);
	}

	function captureLead() {
		if (!EARLY_LEAD_CAPTURE || leadCaptured) return;
		leadCaptured = true;
		saveProgress();
		postToHubspot(buildFields(), "", true).catch((err) => console.error(LOG_PREFIX, "captação inicial", err));
	}

	function recordExit() {
		const slug = EXIT_STEP[currentStep];
		if (!slug) return;
		log("desistência", currentStep, slug);
		postToHubspot(buildFields([
			{ name: EXIT_FIELD, value: slug },
			{ name: "origem_de_cadastro_staging", value: ORIGIN_DESISTENTE },
			{ name: "origem_de_cadastro__crm__staging", value: ORIGIN_DESISTENTE },
		]), "", true).catch((err) => console.error(LOG_PREFIX, "desistência", err));
	}

	function ensureUploadFrame() {
		return new Promise((resolve) => {
			const existing = document.getElementById(UPLOAD_IFRAME_NAME);
			if (existing) return resolve(existing);

			const iframe = document.createElement("iframe");
			iframe.name = UPLOAD_IFRAME_NAME;
			iframe.id = UPLOAD_IFRAME_NAME;
			iframe.hidden = true;

			let settled = false;
			const done = () => {
				if (settled) return;
				settled = true;
				resolve(iframe);
			};
			iframe.addEventListener("load", done, { once: true });
			window.setTimeout(done, 1000);
			document.body.appendChild(iframe);
		});
	}

	function uploadFiles(email, files) {
		if (!files.length) return Promise.resolve();

		return new Promise((resolve) => {
			let done = false;
			const finish = () => {
				if (done) return;
				done = true;
				resolve();
			};
			window.setTimeout(finish, FILE_UPLOAD_WAIT_MS);

			ensureUploadFrame().then((iframe) => {
				try {
					const form = document.createElement("form");
					form.action = FILE_UPLOAD_URL;
					form.method = "POST";
					form.enctype = "multipart/form-data";
					form.target = UPLOAD_IFRAME_NAME;
					form.hidden = true;

					const addHidden = (name, value) => {
						const input = document.createElement("input");
						input.type = "hidden";
						input.name = name;
						input.value = value;
						form.appendChild(input);
					};
					addHidden("email", email);
					addHidden("hs_context", JSON.stringify({
						pageUri: window.location.href,
						pageName: document.title,
						hutk: getHutk(),
					}));

					const fileInput = document.createElement("input");
					fileInput.type = "file";
					fileInput.name = FILE_FIELD;
					fileInput.multiple = true;
					const dt = new DataTransfer();
					files.forEach((f) => dt.items.add(f));
					fileInput.files = dt.files;
					form.appendChild(fileInput);

					iframe.addEventListener("load", finish, { once: true });
					document.body.appendChild(form);
					log("upload", files.map((f) => f.name));
					form.submit();
					window.setTimeout(() => form.remove(), 30000);
				} catch (err) {
					console.error(LOG_PREFIX, "upload", err);
					finish();
				}
			});
		});
	}

	function setSubmitLoading(loading) {
		const btn = $("[data-submit]");
		if (!btn) return;
		btn.disabled = loading;
		btn.setAttribute("aria-busy", loading ? "true" : "false");
	}

	function showStep(step) {
		const steps = modal.querySelectorAll(".form-step");
		steps.forEach((el) => el.classList.remove("active"));
		const active = steps[step];
		if (active) active.classList.add("active");

		const isSuccess = !!active && active.getAttribute("data-step") === "success";
		if (container) {
			container.classList.toggle("is-success-step", isSuccess);
			container.classList.toggle("is-wide", WIDE_STEPS.indexOf(step) !== -1);
		}

		if (step > 0 && step <= totalSteps) {
			$$(".progress-counter").forEach((el) => {
				el.textContent = tpl(i18n.progressTpl || "__C__ / __T__", { C: step, T: totalSteps });
			});
		}

		if (content) content.scrollTop = 0;

		if (step === 3) renderStep3();
		if (step === 4) syncOptionalStepButtons();
		if (step === 5) renderStep5();

		currentStep = step;
		syncNextBtnState(step);
		if (step >= 1 && step <= totalSteps) saveProgress();
	}

	function resetForm() {
		Object.keys(formData).forEach((key) => delete formData[key]);
		openerProductId = "";
		uploadedFiles = [];
		modal.querySelectorAll("input, select").forEach((field) => {
			if (field instanceof HTMLInputElement && field.type === "checkbox") field.checked = false;
			else field.value = "";
			setFieldError(field, false);
		});
		$$(".option-btn.active").forEach((btn) => btn.classList.remove("active"));
		$$(".form-step.has-error").forEach((el) => el.classList.remove("has-error"));
		renderUploads("");
	}

	function restoreDom() {
		[["nome", formData.nome], ["email", formData.email], ["telefone", formData.telefone]].forEach(([name, value]) => {
			const input = $('input[name="' + name + '"]');
			if (input && value) input.value = value;
		});

		const select = $('select[name="data-compra"]');
		if (select && formData.data_compra) {
			select.value = formData.data_compra;
			if (select.value !== formData.data_compra) {
				select.value = "";
				delete formData.data_compra;
			}
		}

		const activate = (step, value) => {
			const el = stepEl(step);
			const btn = value && el && el.querySelector('.option-btn[data-value="' + value + '"]');
			if (btn) btn.classList.add("active");
		};
		activate(2, formData.formato);
		activate(4, formData.line);
		activate(6, formData.espacioListo);
		activate(8, formData.presupuesto);
		String(formData.color || "").split(",").filter(Boolean).forEach((c) => activate(5, c));

		renderStep5();
		syncOptionalStepButtons();
	}

	function openModal(productId) {
		const saved = loadProgress();
		if (saved && saved.step >= 1 && saved.step <= totalSteps) {
			Object.assign(formData, saved.formData || {});
			openerProductId = saved.productId || "";
			leadCaptured = !!saved.leadCaptured;
			restoreDom();
			currentStep = saved.step;
		} else {
			currentStep = 0;
		}

		if (productId) openerProductId = productId;
		redirecting = false;

		modal.classList.remove("hidden");
		lockScroll(true);
		showStep(currentStep);
	}

	function hideModal() {
		modal.classList.add("hidden");
		hideConfirmExit();
		lockScroll(false);
	}

	function closeModal(force) {
		if (!force && currentStep >= 2 && currentStep <= totalSteps) {
			showConfirmExit();
			return;
		}

		const wasSuccess = currentStep > totalSteps;
		const stepAtClose = currentStep;

		hideModal();
		currentStep = 0;
		resetForm();
		clearProgress();

		if (wasSuccess) {
			goToSuccessPage();
			return;
		}
		if (stepAtClose >= REDIRECT_ON_CLOSE_MIN_STEP) goToThankYou(0);
	}

	function validateStep1() {
		const fields = {
			nome: $('input[name="nome"]'),
			email: $('input[name="email"]'),
			telefone: $('input[name="telefone"]'),
		};
		const checks = {
			nome: (v) => v.trim() !== "",
			email: isValidEmail,
			telefone: isValidPhone,
		};
		let firstInvalid = null;

		Object.keys(fields).forEach((key) => {
			const field = fields[key];
			if (!field) return;
			const ok = checks[key](field.value);
			setFieldError(field, !ok);
			if (ok) formData[key] = field.value.trim();
			else if (!firstInvalid) firstInvalid = field;
		});

		if (firstInvalid) firstInvalid.focus();
		return !firstInvalid;
	}

	function validateCurrentStep() {
		const step = currentStep;
		if (step === 0) return true;
		if (step === 1) return validateStep1();

		if (step === 2 || step === 6 || step === 8) {
			const value = getActiveValue(step);
			setGroupError(step, !value);
			if (!value) return false;
			if (step === 2) formData.formato = value;
			if (step === 6) formData.espacioListo = value;
			if (step === 8) formData.presupuesto = value;
			return true;
		}

		if (step === 3) {
			const step3Inputs = Array.prototype.slice.call($$("[data-step3-inputs] input"));
			const hasAllMeasures = step3Inputs.length > 0 && step3Inputs.every((input) => input.value.replace(/\D/g, "") !== "");
			if (formData.medidas_depois !== "1" && !hasAllMeasures) {
				step3Inputs.forEach((input) => setFieldError(input, !input.value.replace(/\D/g, "")));
				return false;
			}
			step3Inputs.forEach((input) => {
				const digits = input.value.replace(/\D/g, "");
				if (digits) formData[input.name] = digits;
				else delete formData[input.name];
			});
			return true;
		}

		if (step === 4) {
			const value = getActiveValue(4);
			if (value) formData.line = value;
			return true;
		}

		if (step === 5) {
			const colors = getActiveColors();
			setGroupError(5, !colors.length);
			if (!colors.length) return false;
			formData.color = colors.join(",");
			return true;
		}

		if (step === 7) {
			const select = $('select[name="data-compra"]');
			const ok = !!(select && select.value);
			setFieldError(select, !ok);
			if (ok) formData.data_compra = select.value;
			return ok;
		}

		return true;
	}

	function nextStep() {
		if (currentStep >= totalSteps) return;
		if (!validateCurrentStep()) return;

		const advanceEvent = STEP_ADVANCE_EVENTS[currentStep];
		if (advanceEvent) track(advanceEvent);
		if (currentStep === 1) captureLead();

		showStep(currentStep + 1);
	}

	function skipCurrentStep() {
		hideConfirmExit();
		if (currentStep < totalSteps) showStep(currentStep + 1);
	}

	function goBack() {
		if (isConfirmOpen()) {
			hideConfirmExit();
			return;
		}
		if (currentStep > totalSteps) return;
		if (currentStep > 0) {
			showStep(currentStep - 1);
			return;
		}
		closeModal(false);
	}

	async function submitForm() {
		if (isSubmitting) return;
		if (!validateCurrentStep()) return;

		const fileError = validateFiles(uploadedFiles);
		if (fileError) {
			showStep(3);
			renderUploads(fileError);
			return;
		}

		track("presupuesto_modal");
		isSubmitting = true;
		setSubmitLoading(true);

		const filePromise = uploadFiles(String(formData.email || "").trim(), uploadedFiles.slice());

		const extras = ORIGIN_NORMAL.slice();
		if (SEND_COMPLETED_EXIT_STEP) extras.push({ name: EXIT_FIELD, value: EXIT_STEP_COMPLETED });

		try {
			const ip = await getIpAddress();
			await postToHubspot(buildFields(extras), ip, false);
			track("success_form");
			clearProgress();
			showStep(totalSteps + 1);

			// Sem redirecionamento automático: o usuário segue ao clicar em "Continuar".
			// Os anexos continuam subindo em segundo plano; o clique aguarda o fim do envio.
			pendingSuccessUploads = Promise.resolve(filePromise).catch(() => null);
		} catch (error) {
			console.error(LOG_PREFIX, "envio", error);
			window.alert(i18n.submitError || "Error");
		} finally {
			isSubmitting = false;
			setSubmitLoading(false);
		}
	}

	backBtn.addEventListener("click", goBack);
	closeBtn.addEventListener("click", () => closeModal(false));

	// Concluído o formulário: vai para a página de agradecimento (aguarda anexos, máx. 20s)
	function goToSuccessPage() {
		if (redirecting) return;
		redirecting = true;
		if (successCloseBtn) {
			successCloseBtn.disabled = true;
			successCloseBtn.setAttribute("aria-busy", "true");
		}
		const timeout = new Promise((resolve) => window.setTimeout(resolve, SUCCESS_UPLOAD_MAX_WAIT_MS));
		const uploads = pendingSuccessUploads || Promise.resolve();
		Promise.race([uploads, timeout]).then(() => {
			window.location.href = SUCCESS_URL;
		});
	}

	if (successCloseBtn) {
		successCloseBtn.addEventListener("click", goToSuccessPage);
	}

	if (confirmStayBtn) confirmStayBtn.addEventListener("click", hideConfirmExit);
	if (confirmSkipBtn) confirmSkipBtn.addEventListener("click", skipCurrentStep);
	if (confirmLeaveBtn) {
		confirmLeaveBtn.addEventListener("click", () => {
			recordExit();
			saveProgress();
			hideModal();
			if (REDIRECT_ON_EXIT) goToThankYou(250);
		});
	}

	if (confirmOverlay) {
		confirmOverlay.addEventListener("click", (e) => {
			if (e.target === confirmOverlay) hideConfirmExit();
		});
	}

	const OPEN_HASHES = ["#abrir-quiz", "#quiz-proyectos"];

	function isHashTrigger(el) {
		if (!el) return false;
		const raw = el.getAttribute("href") || "";
		const hash = el.hash || "";
		return OPEN_HASHES.some((h) => hash === h || raw === h || raw.endsWith(h));
	}

	function getProductId(trigger) {
		const holder = trigger && trigger.closest("[data-product-id]");
		return holder ? String(holder.getAttribute("data-product-id") || "").trim() : "";
	}

	document.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;

		const trigger =
			e.target.closest("[data-project-start-ar-open], [data-project-start-open], [data-opens-quiz]") ||
			(isHashTrigger(e.target.closest("a[href]")) && e.target.closest("a[href]")) ||
			(() => {
				const el = e.target.closest("[data-scroll-to]");
				return el && OPEN_HASHES.indexOf("#" + el.getAttribute("data-scroll-to")) !== -1 ? el : null;
			})();

		if (!trigger) return;
		e.preventDefault();
		openModal(getProductId(trigger));
	});

	if (OPEN_HASHES.indexOf(window.location.hash) !== -1) {
		openModal("");
	}

	modal.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;

		const removeBtn = e.target.closest("[data-upload-remove]");
		if (removeBtn) {
			e.preventDefault();
			removeFile(Number(removeBtn.getAttribute("data-upload-remove")));
			return;
		}

		const optionBtn = e.target.closest(".option-btn");
		const optionStep = optionBtn && optionBtn.closest(".form-step");
		if (optionBtn && optionStep) {
			const step = Number(optionStep.getAttribute("data-step"));
			const value = optionBtn.getAttribute("data-value");

			if (step === 5) {
				if (optionBtn.classList.contains("active")) optionBtn.classList.remove("active");
				else if (getActiveColors().length < 2) optionBtn.classList.add("active");
				formData.color = getActiveColors().join(",");
			} else {
				optionStep.querySelectorAll(".option-btn.active").forEach((btn) => btn.classList.remove("active"));
				optionBtn.classList.add("active");
				if (step === 2) {
					formData.formato = value;
					renderStep3();
				}
				if (step === 4) {
					formData.line = value;
					syncOptionalStepButtons();
				}
				if (step === 6) formData.espacioListo = value;
				if (step === 8) formData.presupuesto = value;
			}

			setGroupError(step, false);
			syncNextBtnState(step);
			saveProgress();
		}

		if (e.target.closest("[data-next-step]")) nextStep();
		else if (e.target.closest("[data-submit]")) submitForm();
	});

	modal.addEventListener("input", (e) => {
		const field = e.target;
		if (!(field instanceof HTMLInputElement)) return;
		const name = field.name;

		if (name === "telefone") field.value = formatPhoneTyping(field.value);

		if (name === "nome" || name === "email" || name === "telefone") {
			formData[name] = field.value;
			setFieldError(field, false);
			syncNextBtnState(1);
		}

		if (/^parede\d$/.test(name)) {
			const digits = field.value.replace(/\D/g, "");
			const suffix = typeof i18n.unitCmSuffix === "string" ? i18n.unitCmSuffix : " cm";
			field.value = digits ? digits + suffix : "";
			if (digits) {
				field.setSelectionRange(digits.length, digits.length);
				formData[name] = digits;
			} else {
				delete formData[name];
			}
			syncOptionalStepButtons();
		}
	});

	modal.addEventListener("change", (e) => {
		const field = e.target;

		if (field instanceof HTMLSelectElement && field.name === "data-compra") {
			formData.data_compra = field.value;
			setFieldError(field, !field.value);
			syncNextBtnState(7);
			saveProgress();
			return;
		}

		if (!(field instanceof HTMLInputElement)) return;

		if (field.name === "nome" || field.name === "email" || field.name === "telefone") {
			formData[field.name] = field.value;
			syncNextBtnState(1);
		}

		if (field.name === "step3_medidas_depois") {
			if (field.checked) formData.medidas_depois = "1";
			else delete formData.medidas_depois;
			syncStep3LaterOption();
			syncOptionalStepButtons();
			saveProgress();
		}

		if (field.name === "step3_space_file") addFiles(field.files);
	});

	modal.addEventListener("focusout", (e) => {
		const field = e.target;
		if (field instanceof HTMLInputElement && field.name === "telefone" && isValidPhone(field.value)) {
			field.value = formatPhone(field.value);
			formData.telefone = field.value;
		}
	});

	modal.addEventListener("keydown", (e) => {
		if (e.key !== "Enter" || !(e.target instanceof HTMLInputElement)) return;
		if (e.target.type === "file") return;
		e.preventDefault();

		const step = e.target.closest(".form-step");
		const inputs = step ? Array.prototype.slice.call(step.querySelectorAll("input:not([type=hidden]):not([type=file])")) : [];
		const next = inputs[inputs.indexOf(e.target) + 1];
		if (next && !next.value) next.focus();
		else nextStep();
	});

	document.addEventListener("keydown", (e) => {
		if (e.key !== "Escape" || modal.classList.contains("hidden")) return;
		if (isConfirmOpen()) hideConfirmExit();
		else closeModal(false);
	});

	const persistOnLeave = () => {
		if (currentStep >= 1 && currentStep <= totalSteps && !modal.classList.contains("hidden")) saveProgress();
	};
	window.addEventListener("pagehide", persistOnLeave);
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "hidden") persistOnLeave();
	});

	buildMonthOptions();
	syncOptionalStepButtons();

	win.arModalProjeto = { open: openModal, close: () => closeModal(true) };
})();
